import { useState, useEffect } from "react";
import api from "../../../../../features/auth/axiosConfig";
import { CategoryButton } from "../../../../../shared/services/interface";

export const useCategoryData = () => {
  const [buttonNames, setButtonNames] = useState<CategoryButton[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const getCategory = () => {
    setLoading(true);
    api(`/app/v1/pos/category?include_deleted=False&pageNumber=&pageSize=`)
      .then((res) => {
        const getCategory = res.data;
        const categoryData: CategoryButton[] = getCategory.category_details;
        setButtonNames(categoryData);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getCategory();
  }, []);

  return { buttonNames, loading, getCategory };
};
